import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import AcomodacaoPage from "@/pages/AcomodacaoPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/acomodacao/:slug" element={<AcomodacaoPage />} />
        </Routes>
        <Footer />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
